import React from 'react'

export default ({width, height}) => (
  <svg className="shape shape--alert" width={width} height={height} viewBox="0 0 24 24">
    <path d='M1.50123914,19.1342376 L11.4989431,1.86576235 C11.7804494,1.3795322 12.2245872,1.38761501 12.5014048,1.86576235 L22.4987775,19.1342376 C22.7802745,19.6204678 22.5511826,20 21.9975383,20 L2.00246167,20 C1.43945834,20 1.22441241,19.612385 1.50123914,19.1342376 Z M12,4.50411444 L4.5,18 L19.5,18 L12,4.50411444 Z M13,17 L11,17 L11,15 L13,15 L13,17 L13,17 Z M12,14 C11.4477153,14 11,13.5562834 11,13.0001925 L11,9.99980749 C11,9.44762906 11.4438648,9 12,9 L12,9 C12.5522847,9 13,9.44371665 13,9.99980749 L13,13.0001925 C13,13.5523709 12.5561352,14 12,14 L12,14 Z'></path>
  </svg>
)


// WEBPACK FOOTER //
// ./src/components/Shapes/Alert.js